export enum AuroraBoilerRunPermitStatus {
  ON = 'on',
  OFF = 'off'
}

export default AuroraBoilerRunPermitStatus
